module.exports = __webpack_public_path__ + "static/media/Vikavolt_gaussian2.0f196199.png";